import React from "react";

import { noimage } from "../../../../assets";

export const montarTipoPartilha = (documento, listarParticipantes) => {
    if (documento.tipoPartilha === "PESSOAL") {
        return <i className="fas fa-user icon-tipo-partilha pessoal" title="Pessoal" />;
    }

    if (documento.tipoPartilha === "INSTRUTORES") {
        return <i className="fas fa-user-friends icon-tipo-partilha partilhado-instrutor" title="Professores" />;
    }

    if (documento.totalParticipantes === 1 && !documento.todos) {
        const utilizador = documento.participante;

        return (
            <div className="info-autor">
                <div className="container-img">
                    <img src={utilizador?.foto || noimage} />
                </div>
                <div className="info">
                    <span className="nome">{utilizador?.nome_completo}</span>
                    <p className="numero">{utilizador?.numero}</p>
                </div>
            </div>
        );
    }

    return (
        <span
            className="link-model-participantes"
            /*onClick={() => listarParticipantes(documento.id)}*/
            style={{ cursor: "pointer" }}
        >
            <i className="fas fa-users icon-tipo-partilha partilhado" title="Turma" />
        </span>
    );
};
